import React from 'react';
import { TakeoverLinks } from '../components/ui/take-over-links';

const Categories = () => {
    return (
        <div className='h-screen overflow-hidden'>
            <div className="flex justify-center flex-wrap">
                <TakeoverLinks />
            </div>
        </div>
    );
};

export default Categories;